import { render, staticRenderFns } from "./BettingOffer.vue?vue&type=template&id=29fec88b&scoped=true"
import script from "./BettingOffer.vue?vue&type=script&lang=js"
export * from "./BettingOffer.vue?vue&type=script&lang=js"
import style0 from "./BettingOffer.vue?vue&type=style&index=0&id=29fec88b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fec88b",
  null
  
)

export default component.exports